var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF5858",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.985 16.684a1.35 1.35 0 0 0-1.334 1.334 1.35 1.35 0 0 0 1.334 1.335c.7 0 1.335-.608 1.303-1.302a1.303 1.303 0 0 0-1.303-1.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.34 21.414a4.558 4.558 0 0 0 .01-4.613L16.99 2.322a4.542 4.542 0 0 0-4-2.322c-1.676 0-3.17.87-3.998 2.317L.62 16.812a4.594 4.594 0 0 0 .016 4.64 4.569 4.569 0 0 0 3.988 2.29h16.7c1.67 0 3.17-.87 4.014-2.328zm-1.816-1.046a2.523 2.523 0 0 1-2.205 1.276H4.62a2.488 2.488 0 0 1-2.178-1.25 2.526 2.526 0 0 1-.005-2.546l8.371-14.49a2.477 2.477 0 0 1 2.184-1.265c.913 0 1.73.475 2.183 1.27l8.366 14.49c.449.78.443 1.72-.016 2.515z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.654 7.314c-.635.182-1.03.758-1.03 1.458.032.421.059.849.09 1.27l.273 4.79c.032.544.454.939.998.939.545 0 .972-.422.999-.972 0-.33 0-.635.032-.971.058-1.03.123-2.061.181-3.092.032-.667.091-1.334.123-2.002 0-.24-.032-.454-.123-.667a1.338 1.338 0 0 0-1.543-.753z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.6a0cda5c.svg";
export { ForwardRef as ReactComponent };